import {
  createTopLevelAction,
  createViewerAction,
} from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { getBookInfoStatus } from "./selectors";
import TopLevelMethod from "../../core/TopLevelMethod";

const fetchBookInfo = createViewerAction(ViewerMethod.GET_BOOK_INFO);

export const fetchBookInfoIfNeeded = () => (dispatch, getState) => {
  if (getBookInfoStatus(getState()) === DetailedLoadStatus.WAITING) {
    return dispatch(fetchBookInfo());
  }
};

const fetchBookInfoForIsbn = createTopLevelAction(TopLevelMethod.GET_BOOK_INFO);

export const fetchBookInfoForPossibleIsbn = (possibleIsbn) => (dispatch) => {
  const isWorthSearchingFor = !!possibleIsbn.match("^[a-zA-z0-9-]+$");
  if (isWorthSearchingFor) {
    return dispatch(fetchBookInfoForIsbn(possibleIsbn));
  }
  return Promise.resolve({ ok: true, data: undefined });
};
